<template>
  <v-fade-transition>
    <!-- 2F73F2 -->
    <v-btn
      v-show="showBtn"
      fab
      fixed
      bottom
      right
      color="#215295"
      class="back-to-top-btn"
      aria-label="Back to top"
      @click="scrollToTop"
    >
      <v-icon color="white">mdi-chevron-up</v-icon>
    </v-btn>
  </v-fade-transition>
</template>

<script>
export default {
  name: 'BackToTop',

  props: {
    // ระยะ scroll (px) ที่จะแสดงปุ่ม
    threshold: {
      type: Number,
      default: 100,
    },
    // ความเร็วในการ scroll ขึ้น (ms)
    duration: {
      type: Number,
      default: 100,
    },
  },

  data() {
    return {
      showBtn: false,
    }
  },

  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },

  methods: {
    onScroll() {
      this.showBtn = window.scrollY > this.threshold
    },

    scrollToTop() {
      const start = window.scrollY
      const startTime = performance.now()

      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / this.duration, 1)
        // easeInOutCubic
        const ease =
          progress < 0.5
            ? 4 * progress ** 3
            : 1 - (-2 * progress + 2) ** 3 / 2

        window.scrollTo(0, start * (1 - ease))

        if (progress < 1) {
          requestAnimationFrame(animateScroll)
        }
      }

      requestAnimationFrame(animateScroll)
    },
  },
}
</script>

<style scoped>
.back-to-top-btn {
  position: fixed !important;
  bottom: 20px !important;
  right: 20px !important;
  z-index: 999;
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  border-radius: 50% !important;        /* ✅ วงกลม */
  padding: 0 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease !important;
}

.back-to-top-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35) !important;
}
</style>